class StickyHeader extends HTMLElement {
  connectedCallback() {
    this.sentinel = document.createElement('div');
    this.sentinel.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:1px;pointer-events:none;';
    this.before(this.sentinel);

    this.observer = new IntersectionObserver(
      ([entry]) => this.classList.toggle('is-stuck', !entry.isIntersecting),
      { rootMargin: '-1px 0px 0px 0px', threshold: 0 }
    );
    this.observer.observe(this.sentinel);
  }
  disconnectedCallback() {
    this.observer?.disconnect();
    this.sentinel?.remove();
  }
}
customElements.define('sticky-header', StickyHeader);
